'use strict';

class ContactForm {
	constructor (options) {
		this.form = options.elements['form'];
		this.language_selector = options.elements['language_selector'];
		this.chat_offset = options.elements['chat_offset'];

		this.chat_offset.value = options.offset;
		this.add_events();
	}

	add_events () {
		document
			.querySelectorAll('#form_contact input[name="contact_options"]')
			.forEach((radio) => {
				radio.addEventListener('change', (e) => {
					let target = e.target;
					switch (target.value) {
						case 'email_reply':
							this.form.setAttribute('action', s.url('/process_contact'));
							$(this.language_selector).slideUp();
							break;

						case 'chat_with_us':
							this.form.setAttribute('action', s.url('/chat/window'));
							$(this.language_selector).slideUp();
							$(this.language_selector + '#chat_with_us').slideDown();
							break;

						default:
							this.form.setAttribute('action', s.url('/'));
							$(this.language_selector).slideUp();
					}

					this.form
						.querySelector('[type="submit"]')
						.removeAttribute('disabled');
				});
			});

		if (this.form) {
			const submitHandler = () => {
				if (document.querySelector('input[name="contact_options"]:checked').value == 'chat_with_us') {
					window.open('about:blank', 'chat_window', 'toolbar=0,scrollbars=0,location=0,statusbar=0,menubar=0,resizable=0,width=500,height=531');
					this.form.target = 'chat_window';
				} else {
					this.form.target = '_self';
				}

				this.form
					.querySelector('[type="submit"]')
					.setAttribute('disabled', 'disabled');

				this.form.submit();
			}
			const constrants = {
				name: {presence: true},
				email: {
					presence: true,
					email: true
				},
				phone: {
					presence: true,
					numericality: {
						onlyInteger: true,
						message: '^' + s.options.messages.ERROR_ENTER_DIGITS_ONLY
					}
				},
				category_name: {presence: true},
				message: {
					presence: true,
					length: {								
						minimum: 20,
						maximum: 5000,
						message: '^' + s.options.messages.ERROR_ENTER_TEXT_BETWEEN.replace('{0}', 20).replace('{1}', 5000),
					}
				}
			}
			new FormValidator({formSubmitHandler:submitHandler, inputContainer:'js-form-group', clearDisabledStatusOnButton: true}).start(this.form, constrants);

			const selectElement = this.form.querySelector('select[name="category_name"]');
			selectElement.addEventListener('change', function(event) {
				const hintElements = document.querySelectorAll('[data-hint-id]:not(.d-none)');
				hintElements.forEach(el => {
					el.classList.add('d-none');
				});

				const hint = this.form.querySelector(`[data-hint-id="${event.target?.selectedOptions[0]?.dataset?.catId}"]`);
				if (hint) {
					hint.classList.remove('d-none');
				}
			  });
		}
	}
}
